import { all } from 'redux-saga/effects';
import authSaga from '@mins/redux/auth/saga';
import ecommerceSaga from '@mins/redux/ecommerce/saga';

export default function* rootSaga(getState) {
  yield all([authSaga(), ecommerceSaga()]);
}
